<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100 font-robo">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="main" data-request="1335">
          <div class="wrap">
            <div class="offer elem" style="display: block;">
              <div class="row">
                <div class="col col-12">
                  <div class="head">
                    <h2>طرح های پیشنهادی</h2>
                    <p>لطفا یکی از طرح های پیشنهادی را انتخاب کنید</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <div class="offers" *ngIf="companyOffers && formGroup.controls.companyName &&  formGroup.controls.companyName.value">
                    <app-radio-button *ngIf="companies.length > 1" [translation]="translation" [fieldName]="'companyName'"
                                      [Group]="formGroup"
                                      [list]="companies"
                    ></app-radio-button>
                    <div>
                      <div *ngFor="let offer of companyOffers[formGroup.controls.companyName.value]"
                           class="item">
                        <div class="card" style="text-align: right">
                          <div class="touch"><label class="checkbox">
                            <input (change)="onSelectionChange(offer)"
                                   name="health-offer" type="radio" value="1" class="input input-health-offer">
                            <span>{{offer.name}}</span></label>
                            <div class="info" id="{{offer.id}}">
                              <div class="row">
                                <div class="col col-7"><span>نام شرکت</span></div>
                                <div class="col col-5"><span dir="ltr">{{offer.companyName}}</span></div>
                              </div>
                              <div *ngFor="let item of offer.services">
                                <div class="row">
                                  <div class="col col-12" style="text-align: right"><span>{{item}}</span></div>
                                </div>
                                <br/>
                              </div>
                              <div class="row">
                                <div class="col col-7"><span>{{settings.translateEnglish('overAllCoverage', translation)}}</span></div>
                                <div class="col col-5"><span class="mark" dir="ltr">{{offer.overAllCoverage}}</span>
                                  <span>تومان</span>
                                </div>
                              </div>
                              <div *ngFor="let item of offer.discountsList" class="row">
                                <div class="discounts">
                                  <span>{{item}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="payment">
                              <div class="row">
                                <div class="col col-6 price-label">
                                  <span>حق بیمه</span>
                                </div>
                                <div class="col col-6">
                                  <div class="amount amount-discount"
                                       *ngIf="offer.discountedAmount !== offer.cost">
                                    <span class="mark old-price"
                                          dir="ltr">{{offer.discountedAmount}}</span>
                                    <span>تومان</span>
                                  </div>
                                  <div
                                    [ngClass]="offer.discountedAmount !== offer.cost ? 'amount' : ''">
                                    <span class="mark"
                                          dir="ltr">{{offer.cost}}</span>
                                    <span>تومان</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-custom-button
                [BackButton]="true"
                [disabled]="!formGroup.valid"
                [LabelText]="'ادامه'"
                [Show]="true"
                (OnClick)="submit()"
                [backUrl]="'/' + productName + '/basic-information'"
              ></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
